{
	"download": "Descargar",
	"editMassProduct": "Edición masiva de productos",
	"label": "Nombre de archivo",
	"products": "Productos",
	"selectDisclaimer": "Descargue los productos seleccionados en Excel y edítelos. Luego sube el archivo para actualizar tu menú",
	"sheet": {
		"category": "Categoría",
		"description": "Descripción",
		"filename": "editar-productos-en-masa-delivery",
		"id": "IDENTIFICADOR (NO EDITAR)",
		"invalidFormat": "Formato no válido",
		"name": "Nombre",
		"price": "Precio",
		"sku": "SKU"
	},
	"xlsxDisclaimer": "Ahora que ha editado los productos en excel, cargue el archivo y actualizaremos su lista de productos en este menú"
}
